import { Box, IconButton, Menu, MenuItem } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import Operator from './Operator';
import { PatternCollectionType } from '../../../ChartFieldFilter/UserFilterCardInterface';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import FieldOrDropZones from './FieldOrDropZones';
import { formatDateToYYYYMMDD } from '../../utils';
import { useDispatch } from 'react-redux';
import {
  removeParameterRightOperand,
  setParameterForFlow,
  setRightOperand,
} from '../../../../redux/Calculations/CalculationsActions';
import { fontSize } from '../../../..';
import { useSelector } from 'react-redux';

interface SearchConditionProps {
  propKey: string;
  conditionFilterId: string;
  filterIdx: number;
  operator: string;
  rightOperand: (string | number | null)[];
  rightOperandType: string[];
  disabled?: boolean;
  operatorPattern: PatternCollectionType[];
  leftOperandtype: string;
  timeGrain: string;
}
function SearchCondition({
  propKey,
  conditionFilterId,
  filterIdx,
  operator,
  rightOperand,
  rightOperandType,
  disabled,
  operatorPattern,
  timeGrain,
  leftOperandtype,
}: SearchConditionProps) {
  const { calculations, parameters } = useSelector((state: any) => {
    return {
      calculations: state.calculations,
      parameters: state.parameters,
    };
  });

  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [parameterized1, setParameterized1] = useState<boolean>(false);
  const [parameterized2, setParameterized2] = useState<boolean>(false);
  const [paramSource, setParamSource] = useState<any>([]);

  const _operatorPattern = useMemo(() => operatorPattern, []);

  const currentCalculationSession = calculations.properties[propKey]?.currentCalculationSession;

  const handleAnchorClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleAddButtonClick = () => {
    if (disabled) return;
    if (operator === 'blank') return;
    const newRighToperand = [...rightOperand];
    const newRightOperandType = [...rightOperandType];
    if (rightOperand[0] === null || rightOperand[0] === undefined) {
      newRighToperand[0] = ['integer', 'decimal'].includes(leftOperandtype)
        ? 0
        : ['date', 'timestamp'].includes(leftOperandtype)
          ? timeGrain === 'date'
            ? formatDateToYYYYMMDD(new Date().toISOString().split('T')[0])
            : 0
          : '';
      newRightOperandType[0] = ['integer', 'decimal'].includes(leftOperandtype)
        ? leftOperandtype
        : 'text';
    } else if (rightOperand[1] === null || rightOperand[1] === undefined) {
      newRighToperand[1] = ['integer', 'decimal'].includes(leftOperandtype)
        ? 0
        : ['date', 'timestamp'].includes(leftOperandtype)
          ? timeGrain === 'date'
            ? formatDateToYYYYMMDD(new Date().toISOString().split('T')[0])
            : 0
          : '';
      newRightOperandType[1] = ['integer', 'decimal'].includes(leftOperandtype)
        ? leftOperandtype
        : 'text';
    }
    dispatch(
      setRightOperand(propKey, conditionFilterId, filterIdx, newRighToperand, newRightOperandType),
    );
  };

  const disableButton = () => {
    if (disabled || operator === 'blank') return true;
    if (operator !== 'between') {
      return (rightOperand[0] !== null && rightOperand[0] !== undefined) || parameterized1;
    }
    return (rightOperand.length === 2 && !rightOperand.includes(null)) || parameterized1;
    // if (operator !== 'between') {
    //   if (parameterized1) return true;
    //   return rightOperand[0] !== null && rightOperand[0] !== undefined;
    // }
    // if (rightOperand[0] !== null && rightOperand[0] !== undefined) {
    //   if (parameterized2) return true;
    // }
    // if (rightOperand.length === 2 && !rightOperand.includes(null)) {
    //   return true;
    // }
    // return false;
  };

  const handleSelectParameter = () => {
    if (operator === 'between') {
      const rightOperand =
        calculations.properties[propKey].currentCalculationSession.calculationInfo.conditionFilters[
          conditionFilterId
        ][0].conditions[filterIdx].rightOperand;
      if (rightOperand[0] !== null || rightOperand[1] !== null || rightOperand.length >= 1) {
        dispatch(removeParameterRightOperand(propKey, conditionFilterId, filterIdx));
      }
    }
    setAnchorEl(null);
    setParameterized1(true);
  };

  useEffect(() => {
    if (!currentCalculationSession) return;

    const isParameterPresent =
      currentCalculationSession.calculationInfo.conditionFilters[conditionFilterId][0].conditions[
        filterIdx
      ].parameterId.length > 0;
    dispatch(
      setParameterForFlow(propKey, currentCalculationSession?.activeFlow, isParameterPresent),
    );
  }, [
    currentCalculationSession?.calculationInfo?.conditionFilters[conditionFilterId][0]?.conditions[
      filterIdx
    ],
  ]);

  useEffect(() => {
    setParameterized1(false);
    // setParameterized2(false);
  }, [
    operator,
    currentCalculationSession?.calculationInfo?.conditionFilters[conditionFilterId!][0].conditions[
      filterIdx!
    ].timeGrain,
  ]);

  return (
    <Box id="search-condition">
      <Box
        sx={{
          display: 'flex',
          gap: '0.3rem',
          alignItems: 'center',
        }}
      >
        <Operator
          propKey={propKey}
          conditionFilterId={conditionFilterId}
          filterIdx={filterIdx}
          operator={operator}
          disabled={disabled}
          operators={_operatorPattern}
        />

        <IconButton
          onClick={handleAnchorClick}
          disabled={disableButton()}
          area-label="add-custom-field"
          sx={{
            padding: 0,
          }}
        >
          <AddCircleOutlineIcon
            sx={{
              fontSize: '20px',
              color: disableButton() ? '#d3d3d3' : '#2bb9bb',
            }}
          />
        </IconButton>
      </Box>
      {/* New DropDown to choose between static values and parameterized */}
      <Menu
        id="lock-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        MenuListProps={{
          'aria-labelledby': 'lock-button',
          role: 'listbox',
        }}
        sx={{
          '& .MuiMenu-paper': {
            boxShadow: '0px 2px 8px rgba(0,0,0,0.4)',
          },
        }}
      >
        <MenuItem
          sx={{
            width: '120px',
            padding: '3px 15px',
            fontSize: fontSize.small,
            '&:hover': {
              backgroundColor: '#40404',
            },
          }}
          onClick={() => {
            setAnchorEl(null);
            handleAddButtonClick();
          }}
        >
          Static values
        </MenuItem>
        <MenuItem
          sx={{
            width: '120px',
            padding: '3px 15px',
            fontSize: fontSize.small,
            '&:hover': {
              backgroundColor: '#40404',
            },
          }}
          onClick={handleSelectParameter}
        >
          Parameterized
        </MenuItem>
      </Menu>

      <Box
        sx={{
          display: 'flex',
          gap: '0.3rem',
          alignItems: 'center',
          marginTop: '0.5rem',
        }}
      >
        {operator === 'blank' ? null : (
          <FieldOrDropZones
            rightOperand={rightOperand}
            rightOperandType={rightOperandType}
            disabled={disabled || operator === 'blank'}
            isBetween={operator === 'between'}
            leftOperandType={leftOperandtype}
            conditionFilterId={conditionFilterId}
            filterIdx={filterIdx}
            propKey={propKey}
            timeGrain={timeGrain}
            paramSource={paramSource}
            setSource={setParamSource}
            parameterized1={parameterized1}
            setParameterized1={setParameterized1}
            parameterized2={parameterized2}
            setParameterized2={setParameterized2}
          />
        )}
      </Box>
    </Box>
  );
}

export default SearchCondition;
